import React from 'react';
import EdgeControllerComponentsList from '../../../shared/components/EdgeControllerComponentsList/EdgeControllerComponentsList';

function EdgeControllerComponents({ edgeControllerId }) {
  return (
    <div className="components-tab-content" style={{ padding: 16 }}>
      <EdgeControllerComponentsList edgeControllerId={edgeControllerId} />
    </div>
  );
}

export default EdgeControllerComponents;
